/* tslint:disable */
/* eslint-disable */
/**
 * Spotnana API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 *  - CHANGEABLE_FLEXIBLE_REFUNDABLE: Changeable, but flight can be non-refundable, partially refundable or fully refundable.
 * @export
 * @enum {string}
 */
export enum ChangeableFilter {
    NoChangeableFilter = 'NO_CHANGEABLE_FILTER',
    ChangeableFlexibleRefundable = 'CHANGEABLE_FLEXIBLE_REFUNDABLE',
    RefundableWithPenalty = 'REFUNDABLE_WITH_PENALTY',
    RefundableWithoutPenalty = 'REFUNDABLE_WITHOUT_PENALTY'
}



